import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface CancelAgentTestRunData {
  processId: number;
  runUuid: string;
}

interface CancelAgentTestRunResponse {
  data: any;
}

export function useCancelAgentTestRun() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      processId,
      runUuid,
    }: CancelAgentTestRunData): Promise<CancelAgentTestRunResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_AI_ENGINE_ENDPOINT
        }/api/v1/bundles/agent_runtime_bundle/functions/cancel_agent_test_run`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({
            processId,
            runUuid,
          }),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
